__turbopack_context__.v({
  "content": "skeleton-loader-module-scss-module__ReA1nW__content",
  "sidebar": "skeleton-loader-module-scss-module__ReA1nW__sidebar",
});
